import { createTermTagManager } from '../../utils/createTermTagManager';

export const isSeparatedInputTypeTagManager = createTermTagManager({
  jsonQueryKey: 'is_separated_input_type',
  label: 'Отдельный вход',
  id: 'isSeparatedInputType',
});
